import { useEffect, useState } from "react";
import "@/App.css";
import { Phone } from "lucide-react";
import { Toaster } from "sonner";
import axios from "axios";
import Header from "./components/Header";
import SEOHeader from "./components/SEOHeader";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import ServicesSection from "./components/ServicesSection";
import RealizationsSection from "./components/RealizationsSection";
import GoogleReviewsSection from "./components/GoogleReviewsSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import MentionsLegales from "./components/MentionsLegales";
import PolitiqueConfidentialite from "./components/PolitiqueConfidentialite";
import InstallationPACVilleneuveSurLot from "./components/InstallationPACVilleneuveSurLot";
import InstallationPACSainteLivradeSurLot from "./components/InstallationPACSainteLivradeSurLot";
import InstallationPACFumel from "./components/InstallationPACFumel";
import InstallationPACCasseneuil from "./components/InstallationPACCasseneuil";
import InstallationPACPenneDAgenais from "./components/InstallationPACPenneDAgenais";
import InstallationPACBias from "./components/InstallationPACBias";
import InstallationPACPujols from "./components/InstallationPACPujols";
import InstallationPACMonflanquin from "./components/InstallationPACMonflanquin";
import InstallationPACMonsempronLibos from "./components/InstallationPACMonsempronLibos";
import InstallationPACCancon from "./components/InstallationPACCancon";
import InstallationPACMiramontDeGuyenne from "./components/InstallationPACMiramontDeGuyenne";
import InstallationPACTonneins from "./components/InstallationPACTonneins";
import InstallationPACVillereal from "./components/InstallationPACVillereal";
import InstallationPACCastillonnes from "./components/InstallationPACCastillonnes";
import InstallationPACAiguillon from "./components/InstallationPACAiguillon";
import InstallationPACDamazan from "./components/InstallationPACDamazan";
import InstallationPACPortSainteMarie from "./components/InstallationPACPortSainteMarie";
import InstallationPACClairac from "./components/InstallationPACClairac";
import InstallationPACLotEtGaronne from "./components/InstallationPACLotEtGaronne";
import InstallationClimLotEtGaronne from "./components/InstallationClimLotEtGaronne";
import DevisPAC from "./components/DevisPAC";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function App() {
  const [reviewRating, setReviewRating] = useState(5);
  const [reviewTotal, setReviewTotal] = useState(0);

  useEffect(() => {
    axios.get(`${API}/google-reviews`).then(res => {
      setReviewRating(res.data.rating);
      setReviewTotal(res.data.total);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
    );
    const elements = document.querySelectorAll(".scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-scale");
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
  if (window.location.pathname === "/") {
    document.title = "Alter Energies — Pompe à Chaleur & Climatisation Lot-et-Garonne (47) | Chauffagiste RGE";
    const meta = document.querySelector('meta[name="description"]');
    const content = "Alter Energies, chauffagiste certifié RGE QualiPAC en Lot-et-Garonne. Installation pompe à chaleur, climatisation, remplacement chaudière fioul. 500+ installations, devis gratuit, aides MaPrimeRénov' et CEE gérées.";
    if (meta) { meta.setAttribute("content", content); } else { const m = document.createElement("meta"); m.name = "description"; m.content = content; document.head.appendChild(m); }
  }
}, []);
  const path = window.location.pathname;
  if (path === "/mentions-legales") {
    return (
      <>
        <Header rating={reviewRating} totalReviews={reviewTotal} />
        <MentionsLegales />
        <FooterSection />
      </>
    );
  }
  if (path === "/politique-de-confidentialite") {
    return (
      <>
        <Header rating={reviewRating} totalReviews={reviewTotal} />
        <PolitiqueConfidentialite />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-villeneuve-sur-lot") {
    return (
      <>
        <SEOHeader />
        <InstallationPACVilleneuveSurLot />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-sainte-livrade-sur-lot") {
    return (
      <>
        <SEOHeader />
        <InstallationPACSainteLivradeSurLot />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-fumel") {
    return (
      <>
        <SEOHeader />
        <InstallationPACFumel />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-casseneuil") {
    return (
      <>
        <SEOHeader />
        <InstallationPACCasseneuil />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-penne-d-agenais") {
    return (
      <>
        <SEOHeader />
        <InstallationPACPenneDAgenais />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-bias") {
    return (
      <>
        <SEOHeader />
        <InstallationPACBias />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-pujols") {
    return (
      <>
        <SEOHeader />
        <InstallationPACPujols />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-monflanquin") {
    return (
      <>
        <SEOHeader />
        <InstallationPACMonflanquin />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-monsempron-libos") {
    return (
      <>
        <SEOHeader />
        <InstallationPACMonsempronLibos />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-cancon") {
    return (
      <>
        <SEOHeader />
        <InstallationPACCancon />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-miramont-de-guyenne") {
    return (
      <>
        <SEOHeader />
        <InstallationPACMiramontDeGuyenne />
        <FooterSection />
      </>
    );
  }
  if (path === "/installation-pompe-a-chaleur-tonneins") {
  return (
    <>
      <SEOHeader />
      <InstallationPACTonneins />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-villereal") {
  return (
    <>
      <SEOHeader />
      <InstallationPACVillereal />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-castillonnes") {
  return (
    <>
      <SEOHeader />
      <InstallationPACCastillonnes />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-aiguillon") {
  return (
    <>
      <SEOHeader />
      <InstallationPACAiguillon />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-damazan") {
  return (
    <>
      <SEOHeader />
      <InstallationPACDamazan />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-port-sainte-marie") {
  return (
    <>
      <SEOHeader />
      <InstallationPACPortSainteMarie />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-clairac") {
  return (
    <>
      <SEOHeader />
      <InstallationPACClairac />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-pompe-a-chaleur-lot-et-garonne") {
  return (
    <>
      <SEOHeader />
      <InstallationPACLotEtGaronne />
      <FooterSection />
    </>
  );
}
  if (path === "/installation-climatisation-lot-et-garonne") {
  return (
    <>
      <SEOHeader />
      <InstallationClimLotEtGaronne />
      <FooterSection />
    </>
  );
}
  if (path === "/devis-pompe-a-chaleur") {
  return <DevisPAC />;
}
  return (
    <div className="min-h-screen bg-white" data-testid="app-root">
      <Toaster position="top-right" richColors />
      <Header rating={reviewRating} totalReviews={reviewTotal} />
      <main>
        <HeroSection />
        <StatsSection />
        <ServicesSection />
        <RealizationsSection />
{/* Zone d'intervention homepage */}
<section className="py-16 bg-[#F9FAFB]">
  <div className="container mx-auto px-4 md:px-6 max-w-7xl">
    <div className="text-center mb-10 scroll-reveal">
      <h2 className="text-3xl font-bold text-gray-900 mb-4">Nous intervenons dans tout le <span className="text-[#6AB023]">Lot-et-Garonne</span></h2>
      <p className="text-gray-600 max-w-2xl mx-auto">François se déplace gratuitement chez vous pour un diagnostic et un devis. Trouvez votre commune.</p>
    </div>
    <div className="flex flex-wrap justify-center gap-3 scroll-reveal">
      <a href="/installation-pompe-a-chaleur-lot-et-garonne" className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-[#6AB023] text-white rounded-full text-sm font-bold hover:bg-[#5a9a1e] transition-colors">Tout le Lot-et-Garonne (47)</a>
      <a href="/installation-pompe-a-chaleur-villeneuve-sur-lot" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Villeneuve-sur-Lot</a>
      <a href="/installation-pompe-a-chaleur-tonneins" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Tonneins</a>
      <a href="/installation-pompe-a-chaleur-aiguillon" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Aiguillon</a>
      <a href="/installation-pompe-a-chaleur-fumel" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Fumel</a>
      <a href="/installation-pompe-a-chaleur-sainte-livrade-sur-lot" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Sainte-Livrade-sur-Lot</a>
      <a href="/installation-pompe-a-chaleur-miramont-de-guyenne" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Miramont-de-Guyenne</a>
      <a href="/installation-pompe-a-chaleur-casseneuil" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Casseneuil</a>
      <a href="/installation-pompe-a-chaleur-bias" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Bias</a>
      <a href="/installation-pompe-a-chaleur-pujols" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Pujols</a>
      <a href="/installation-pompe-a-chaleur-penne-d-agenais" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Penne-d'Agenais</a>
      <a href="/installation-pompe-a-chaleur-monflanquin" className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-[#6AB023] hover:text-[#6AB023] transition-colors shadow-sm">Monflanquin</a>
    </div>
    <div className="text-center mt-6">
      <a href="/installation-pompe-a-chaleur-lot-et-garonne" className="text-sm text-[#6AB023] font-semibold hover:underline">Voir toutes nos communes d'intervention →</a>
    </div>
  </div>
</section>
        <GoogleReviewsSection />
        <ContactSection rating={reviewRating} totalReviews={reviewTotal} />
      </main>
      <FooterSection />
      <a href="tel:0628514915" className="fixed bottom-20 right-4 md:hidden z-40 w-14 h-14 bg-[#6AB023] text-white rounded-full flex items-center justify-center" data-testid="floating-phone-btn"><Phone className="w-6 h-6" /></a>
    </div>
  );
}
export default App;
